import React from "react";
import { Formik, Field, Form } from "formik"
import l from "components/util/l";


const AccessView = ({
  organizations,
  activePanel,
  roleOptions,
  setActivePanel,
  onCreateAccess
}) => (

  <div className="card">

    <div className="card-header">
      <h3 className="card-header-title">{l("Crear acceso%PA021")}</h3>
    </div>

    <div className="card-body">
      <Formik
        initialValues={{ type: "" }}
        onSubmit={onCreateAccess}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <div class="text-center">
              <ul class="nav nav-segment mb-5">

                <li class="nav-item">
                  <a class="nav-link active" id="nav-user-tab" data-toggle="pill" href="#nav-user-panel"
                    role="tab" aria-controls="nav-user-panel" aria-selected="true" onClick={() => setActivePanel("email_panel")}>
                    <i class="tio-email nav-icon mr-1"></i> {l("Por correo%PA030")}
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="nav-new-user-tab" data-toggle="pill" href="#nav-new-user-panel"
                    role="tab" aria-controls="nav-new-user-panel" aria-selected="false" onClick={() => setActivePanel("phone_panel")}>
                    <i class="tio-whatsapp nav-icon mr-1"></i> {l("Por teléfono%PA029")}
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="nav-organization-tab" data-toggle="pill" href="#nav-organization-panel"
                    role="tab" aria-controls="nav-organization-panel" aria-selected="false" onClick={() => setActivePanel("organization_panel")}>
                    <i class="tio-company nav-icon mr-1"></i> {l("Por organización%PA028")}
                  </a>
                </li>
              </ul>
            </div>

            <div class="tab-content">

              <div class="tab-pane fade show active" id="nav-user-panel" role="tabpanel" aria-labelledby="nav-user-tab">
                {/* By email */}
                <div class="form-group mb-2">
                  <label class="input-label" for="email">{l("Correo electrónico%GA071")} <span className="text-danger">*</span></label>
                  <Field type="email" name="email" id="email" autocomplete="off"
                    class="form-control form-control" maxlength="512"
                    placeholder={l("Ingresa el correo electrónico%PA027")}
                    autoFocus={true} required={activePanel == "email_panel"} />
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="send-email-notification" class="custom-control-input"
                      onChange={(event) => setFieldValue("send_email_invitation", event.target.checked)} />
                    <label class="custom-control-label" for="send-email-notification">{l("Enviar correo de invitación%PA024")}</label>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="nav-new-user-panel" role="tabpanel" aria-labelledby="nav-new-user-tab">
                {/* By phone */}
                <div class="form-group mb-2">
                  <label class="input-label" for="phone">{l("Teléfono%GA072")} <span className="text-danger">*</span></label>
                  <Field type="phone" name="phone" id="phone" autocomplete="off"
                    class="form-control form-control" maxlength="20"
                    placeholder={l("Ingresa el teléfono%PA026")}
                    autoFocus={true} required={activePanel == "phone_panel"} />
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="send-wa-notification" class="custom-control-input"
                      onChange={(event) => setFieldValue("sent_wa_invitation", event.target.checked)} />
                    <label class="custom-control-label" for="send-wa-notification">{l("Enviar Whatsapp de invitación%PA025")}</label>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade show" id="nav-organization-panel" role="tabpanel" aria-labelledby="nav-organization-tab">
                {/* Organization */}
                <div class="form-group mb-2">
                  <label class="input-label" for="organization">{l("Organización%GA073")} <span className="text-danger">*</span></label>
                  <Field as="select" name="organization" id="organization"
                    class="form-control form-control" required={activePanel == "organization_panel"}
                    onChange={(e) => {
                      const val = e.target.value
                      setFieldValue("organization", val)
                    }}>
                    <option value="">{l("Selecciona una organización%PA023")}</option>
                    {organizations.map((organization) => (
                      <option key={organization.id} value={organization.id}>{organization?.name ?? ""}</option>
                    ))}
                  </Field>
                </div>

                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="send-email-organizations-notification" class="custom-control-input"
                      onChange={(event) => setFieldValue("sent_email_org_invitation", event.target.checked)} />
                    <label class="custom-control-label" for="send-email-organizations-notification">{l("Enviar correo de invitación%PA024")}</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Role */}
            <div class="form-group mb-4 mt-n1">
              <label class="input-label" for="type">Rol <span className="text-danger">*</span></label>
              <Field as="select" name="type" id="type"
                class="form-control form-control" required>
                <option value="">{l("Selecciona un rol%PA022")}</option>
                {roleOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>
            </div>

            <div className="d-flex justify-content-end mb-2 mt-2 w-100">
              <button className="btn btn-primary w-100" type="submit">
                {l("Crear acceso%PA021")}
              </button>
            </div>

          </Form>
        }
      </Formik>
    </div>

  </div>
);

AccessView.propTypes = {};

export default AccessView;